var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluentMail16Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.375C7.37283 6.375 6.29183 6.82277 5.4948 7.6198C4.69777 8.41683 4.25 9.49783 4.25 10.625V11.0521L17 17.918L29.75 11.0543V10.625C29.75 9.49783 29.3022 8.41683 28.5052 7.6198C27.7082 6.82277 26.6272 6.375 25.5 6.375H8.5ZM29.75 13.4661L17.5036 20.06C17.3488 20.1433 17.1758 20.1869 17 20.1869C16.8242 20.1869 16.6512 20.1433 16.4964 20.06L4.25 13.4661V23.375C4.25 24.5022 4.69777 25.5832 5.4948 26.3802C6.29183 27.1772 7.37283 27.625 8.5 27.625H25.5C26.6272 27.625 27.7082 27.1772 28.5052 26.3802C29.3022 25.5832 29.75 24.5022 29.75 23.375V13.4661Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentMail16Filled);
export default __webpack_public_path__ + "static/media/fluent_mail-16-filled.dce935e4fb44ce28e18bbaa7598a6c6c.svg";
export { ForwardRef as ReactComponent };